var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStateSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tick_Icon",
    "data-name": "Tick Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": "!"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_Copy_4",
    "data-name": "Shape Copy 4",
    d: "M11.179.009c-.386.033-.859.09-1.161.141A12.023,12.023,0,0,0,.629,8.109a12.692,12.692,0,0,0-.583,2.615,18,18,0,0,0,0,2.556A12.049,12.049,0,0,0,10.722,23.955a18.007,18.007,0,0,0,2.557,0A12.049,12.049,0,0,0,23.955,13.28a18,18,0,0,0,0-2.556A12.048,12.048,0,0,0,13.29.05C12.99.015,11.462-.015,11.179.009Z",
    fill: "#86d295"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TICK",
    transform: "translate(6 8.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TICK-2",
    "data-name": "TICK",
    d: "M11.717,1.482l-6.73,6.1a1.02,1.02,0,0,1-1.349,0L.281,4.512a.811.811,0,0,1,0-1.228,1.02,1.02,0,0,1,1.349,0l2.7,2.455L10.383.255a1.02,1.02,0,0,1,1.349,0A.822.822,0,0,1,11.717,1.482Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateSuccessIcon);
export default __webpack_public_path__ + "static/media/state-success-icon.9a3627c8.svg";
export { ForwardRef as ReactComponent };